"use client"

// src/components/auth/configuracion/OrganizationDetails.tsx
import type React from "react"
import type { Organization } from "./Configuracion"
import Input from "../../ui/Input"
import Checkbox from "../../ui/Checkbox"
import {
  Building2,
  IdCard,
  FileText,
  MapPin,
  Landmark,
  BadgeDollarSign,
  Fingerprint,
  Key,
  Contact2,
  PhoneCall,
} from "lucide-react"

interface OrganizationDetailsProps {
  organizationFields: Organization
  handleFieldChange: (field: keyof Organization, value: any) => void
}

const OrganizationDetails: React.FC<OrganizationDetailsProps> = ({ organizationFields, handleFieldChange }) => (
  <div className="space-y-8">
    <div className="grid grid-cols-1 md:grid-cols-2 gap-8">
      <div className="bg-white rounded-lg p-6 shadow-sm border border-gray-100">
        <h3 className="text-lg font-semibold text-gray-900 mb-4 flex items-center">
           Información Básica
        </h3>
        <div className="space-y-5">
          <div className="flex items-start">
            <div className="pr-2">
              <Building2 className="text-[#2d53da] h-5 w-5" />
            </div>
            <div className="flex-1">
              <Input
                label="Nombre de la Organización"
                value={organizationFields.name || ""}
                disabled
                fullWidth
                className="bg-gray-50"
              />
            </div>
          </div>
          <div className="flex items-start">
            <div className="pr-2">
              <IdCard className="text-[#2d53da] h-5 w-5" />
            </div>
            <div className="flex-1">
              <Input label="NIT" value={organizationFields.NIT || ""} disabled fullWidth className="bg-gray-50" />
            </div>
          </div>
          <div className="flex items-start">
            <div className="pr-2">
              <FileText className="text-[#2d53da] h-5 w-5" />
            </div>
            <div className="flex-1">
              <Input
                label="Razón Social"
                value={organizationFields.razonSocial || ""}
                onChange={(e) => handleFieldChange("razonSocial", e.target.value)}
                fullWidth
                required
              />
            </div>
          </div>
        </div>
      </div>

      <div className="bg-white rounded-lg p-6 shadow-sm border border-gray-100">
        <h3 className="text-lg font-semibold text-gray-900 mb-4 flex items-center">
           Ubicación y Detalles
        </h3>
        <div className="space-y-5">
          <div className="flex items-start">
            <div className="pr-2">
              <MapPin className="text-[#2d53da] h-5 w-5" />
            </div>
            <div className="flex-1">
              <Input
                label="Dirección"
                value={organizationFields.direccion || ""}
                onChange={(e) => handleFieldChange("direccion", e.target.value)}
                fullWidth
                required
              />
            </div>
          </div>
          <div className="flex items-start">
            <div className="pr-2">
              <Landmark className="text-[#2d53da] h-5 w-5" />
            </div>
            <div className="flex-1">
              <Input
                label="Ciudad"
                value={organizationFields.ciudad || ""}
                onChange={(e) => handleFieldChange("ciudad", e.target.value)}
                fullWidth
              />
            </div>
          </div>
          <div className="flex items-start">
            <div className="pr-2">
              <PhoneCall className="text-[#2d53da] h-5 w-5" />
            </div>
            <div className="flex-1">
              <Input
                label="Contacto"
                value={organizationFields.telefonoContacto || ""}
                onChange={(e) => handleFieldChange("telefonoContacto", e.target.value)}
                fullWidth
                required
              />
            </div>
          </div>
          <div className="flex items-center pt-2">
            <div className="pr-2">
              <BadgeDollarSign className="text-[#2d53da] h-5 w-5" />
            </div>
            <div className="flex-1">
              <Checkbox
                label="Responsable de IVA"
                checked={organizationFields.responsableIVA || false}
                onChange={(e) => handleFieldChange("responsableIVA", e.target.checked)}
              />
            </div>
          </div>
        </div>
      </div>
    </div>

    <div className="bg-white rounded-lg p-6 shadow-sm border border-gray-100">
      <h3 className="text-lg font-semibold text-gray-900 mb-4 flex items-center">
         Facturación Electrónica (DIAN)
      </h3>
      <div className="grid grid-cols-1 md:grid-cols-3 gap-6">
        <div className="flex items-start">
          <div className="pr-2">
            <Fingerprint className="text-[#2d53da] h-5 w-5" />
          </div>
          <div className="flex-1">
            <Input
              label="Identificador"
              value={organizationFields.identificador || ""}
              onChange={(e) => handleFieldChange("identificador", e.target.value)}
              fullWidth
            />
          </div>
        </div>
        <div className="flex items-start">
          <div className="pr-2">
            <Key className="text-[#2d53da] h-5 w-5" />
          </div>
          <div className="flex-1">
            <Input
              label="PIN"
              value={organizationFields.pin || ""}
              onChange={(e) => handleFieldChange("pin", e.target.value)}
              fullWidth
            />
          </div>
        </div>
        <div className="flex items-start">
          <div className="pr-2">
            <Contact2 className="text-[#2d53da] h-5 w-5" />
          </div>
          <div className="flex-1">
            <Input
              label="Set ID"
              value={organizationFields.setId || ""}
              onChange={(e) => handleFieldChange("setId", e.target.value)}
              fullWidth
            />
          </div>
        </div>
      </div>
    </div>
  </div>
)

export default OrganizationDetails